import { render, staticRenderFns } from "./TailwindButton.vue?vue&type=template&id=e0cdb91a&"
import script from "./TailwindButton.vue?vue&type=script&lang=ts&"
export * from "./TailwindButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports